import { createSelector } from 'reselect'

export const getLoading = createSelector(
  state => Boolean(state && state.checkRegistrationCost && state.checkRegistrationCost.isLoading),
  isLoading => isLoading
)
